module.exports = __webpack_public_path__ + "img/144-46561e.png";